import * as size from './size.js'
import { fontDefault } from './preload.js'

export function gen(app, text, fontRate = 1) {
    // Container 1
    const container = new PIXI.Container();

    // Text
    const rate = size.rateX();
    const fontSize = 40 * rate * fontRate;
    const label = new PIXI.Text({ text,
        style: { fontFamily: fontDefault, fontSize, fill: 'white',
            align: 'center', lineHeight: fontSize * 1.5 } });
    label.anchor.x = 0.5;
    label.anchor.y = 0.53;

    // Base
    const marginX = fontSize * 0.9;
    const marginY = fontSize * 0.4;

    const base = new PIXI.Graphics();
    base.rect(0, 0, label.width + marginX * 2, label.height + marginY * 2);

    const gradientFill = new PIXI.FillGradient(0, 0, 0, label.height + marginY * 2);
    gradientFill.addColorStop(0,   0x441100);
    gradientFill.addColorStop(0.3, 0x882200);
    gradientFill.addColorStop(0.7, 0x882200);
    gradientFill.addColorStop(1,   0x441100);
    base.fill(gradientFill);

    base.x = - base.width / 2;
    base.y = - base.height / 2;

    // Container 2
    container.addChild(base);
    container.addChild(label);
    container.x = app.renderer.width / 2;
    container.y = app.renderer.height / 2;
    app.stage.addChild(container);

    return container;
}